import actions from './actions';

const {
  GENERATE_PDF_BEGIN,
  GENERATE_PDF_SUCCESS,
  GENERATE_PDF_ERROR,
} = actions;

const initialState = {
  loading: false,
  error: null,
  pdfUrl: null,
};

const pdfReducer = (state = initialState, action: any) => {
  const { type, data, error } = action;
  switch (type) {
    case GENERATE_PDF_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        pdfUrl: null,
      };
    case GENERATE_PDF_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        pdfUrl: data.pdfUrl,
      };
    case GENERATE_PDF_ERROR:
      return {
        ...state,
        loading: false,
        error,
        pdfUrl: null,
      };
    default:
      return state;
  }
};

export default pdfReducer;